<template>
	<div class="content">
		<Header></Header>
		<loginheader flagg="1" num="1"></loginheader>
		<div class="body">
			<div class="body-header">
				<!-- 轮播 -->
				<!-- <swiper ref="mySwiper" class="swiper-container">
          <div v-for="item in datalist.banner" class="swiper-slide">
            <img class="img" :src="item.bannder_pic" @click="toiInfoDetail(item.id,$event)" />
          </div>
          <div class="swiper-pagination" slot="scrollbar"></div>
				</swiper>-->
				<swiper :options="swiperOption" ref="mySwiper">
					<!-- slides -->
					<swiper-slide v-for="(item,index) in datalist.banner" :key="index" class="swiper-slide">
						<img class="img" :src="item.bannder_pic" @click="toiInfoDetail(item.id,$event)" />
					</swiper-slide>
					<!-- Optional controls -->
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
				<div class="body-header-right">
					<div style="display:flex;flex-direction:row;">
						<div style="width: 6px;height: 20px;background: #365ad2;border-radius: 3px;"></div>
						<div style="font-size: 20px;line-height: 20px;margin-left: 12px;">近期头条</div>
					</div>
					<div style="height:1px;background:#CCCCCC;width:100%;margin:12px 0"></div>
					<div class="body-header-right-smtitle">
						<div
							v-for="(item, index) in datalist.recent"
							:key="index"
							@click="toiInfoDetail(item.id,$event)"
						>{{item.title}}</div>
					</div>
				</div>
			</div>
			<div>
				<img :src="datalist.advert?datalist.advert[0].image:''" class="sidebar-img" />
			</div>
			<!-- 内容 -->
			<div class="body-article">
				<div>
					<div class="body-article-header">
						<div class="row-center">
							<div style="width: 6px;height: 24px;background: #365ad2;border-radius: 3px;"></div>
							<div class="body-article-header-name">{{art2Dname}}</div>
						</div>
						<router-link to="/Exhibition" class="row-center">
							<div class="body-article-header-more">查看更多</div>
							<img src="@/img/yyyyyy.png" class="body-article-header-more-back" />
						</router-link>
					</div>
					<!-- 资讯list -->
					<div class="body-article-list">
						<informItem v-for="(item,index ) in art2D" :item="item" :key="index"></informItem>
					</div>
					<img :src="datalist.advert?datalist.advert[1].image:''" class="sidebar-img2" alt />
					<div class="body-article-header" style="margin-top: 20px;">
						<div class="row-center">
							<div style="width: 6px;height: 24px;background: #365ad2;border-radius: 3px;"></div>
							<div class="body-article-header-name">{{pubArtname}}</div>
						</div>
						<router-link to="/TwoD" class="row-center">
							<div class="body-article-header-more">查看更多</div>
							<img src="../../img/yyyyyy.png" class="body-article-header-more-back" />
						</router-link>
					</div>
					<!-- 资讯list -->
					<div class="body-article-list">
						<informItem v-for="(item,index ) in pubArt" :item="item" :key="index"></informItem>
					</div>
				</div>
				<div class="body-article-right">
					<div class="body-article-right-col1">
						<img :src="recon.logo" class="body-article-right-col1-img" />
						<div>{{recon.title}}</div>
					</div>
					<div style="display:flex;flex-direction: row;margin:22px 0 16px">
						<div style="width: 6px;height: 20px;background: #365ad2;border-radius: 3px;"></div>
						<div style="  font-size: 20px;line-height: 20px;margin-left: 12px;">热门讨论</div>
					</div>
					<div class="body-article-right-col2">
						<div
							class="body-article-right-col2-item"
							v-for="(item, index) in datalist.hotArt"
							:key="index"
						>
							<img :src="item.logo" @click="toiInfoDetail(item.id,$event)" alt />
							<p @click="toiInfoDetail(item.id,$event)">{{item.title}}</p>
						</div>
					</div>
					<div style="display:flex;flex-direction: row;margin:22px 0 16px">
						<div style="width: 6px;height: 20px;background: #365ad2;border-radius: 3px;"></div>
						<div style="  font-size: 20px;line-height: 20px;margin-left: 12px;">原创小说</div>
					</div>
					<div class="body-article-right-col3" @click="towork(newBook.id)">
						<img :src="newBook.cover_pic" />
						<div>{{newBook.title}}</div>
					</div>
				</div>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>
<script language="javascript">
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	import loginheader from "../loginheader.vue";
	import Fotter from "../Fotter.vue";
	import Header from "../Header.vue";
	import informItem from "../informItem.vue";
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {
			loginheader,
			Header,
			Fotter,
			informItem,
			swiper,
			swiperSlide
		},
		data() {
			//这里存放数据
			return {
				datalist: "",
				art2D: "",
				pubArt: "",
				recon: "",
				newBook: "",
				swiperOption: {
					pagination: {
						el: ".swiper-pagination",
						clickable: true
					},
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					}
				},
				pubArtname: "",
				art2Dname: ""
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			toiInfoDetail(id, e) {
				if (e) {
					e.srcElement.style.color = "#B2B2B2";
				}
				const iInfoDetail = this.$router.resolve({
					path: "/infoDetail",
					query: { id: id }
				});
				window.open(iInfoDetail.href, "_blank");
			},
			towork(id) {
				const iInfoDetail = this.$router.resolve({
					path: "/works",
					query: { id: id }
				});
				window.open(iInfoDetail.href, "_blank");
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			var mySwiper = new Swiper(".swiper-container", {
				pagination: {
					el: ".swiper-pagination"
				}
			});
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeCreate() {
			this.$http.get("index").then(res => {
				this.datalist = res.body.data;
				this.art2D = res.body.data.art2D.data;
				this.pubArt = res.body.data.pubArt.data;
				this.recon = res.body.data.recon;
				this.newBook = res.body.data.newBook;
				this.pubArtname = res.body.data.pubArt.data[0].cate.title;
				this.art2Dname = res.body.data.art2D.data[0].cate.title;
			});
		}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>

<style scoped>
	/* @import url(); 引入公共css类 */

	.body-article-list {
		width: 890px;
		height: fit-content;
		min-height: 100px;
		border: 1px solid #cccccc;
		border-radius: 8px;
		margin-top: 20px;
	}

	.body {
		width: 1200px;
		margin: auto;
		padding-top: 20px;
		padding-bottom: 40px;
	}

	.swiper-container {
		width: 780px;
		height: 346px;
		border-radius: 6px;
	}

	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		border-radius: 8px !important;
	}

	.swiper-slide img {
		width: 100%;
		border-radius: 8px !important;
	}

	.body-header-right {
		height: 346px;
		width: 410px;
		border: 1px solid#CCCCCC;
		border-radius: 8px;
		margin-left: 10px;
		padding: 24px 14px;
	}

	.body-header {
		display: flex;
		flex-direction: row;
	}

	.body-header-right-decorate {
		width: 6px;
		height: 20px;
		background: #365ad2;
		border-radius: 3px;
	}

	.body-header-right-smtitle {
		font-size: 14px;
	}

	.body-header-right-smtitle div {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-top: 18px;
		cursor: pointer;
		font-size: 14px;
	}
	.body-header-right-smtitle > div:active {
		color: #cccccc;
	}
	.body-header-right-smtitle > div:hover {
		color: #28a3b1;
	}
	.sidebar-img {
		height: 150px;
		width: 100%;
		margin: 20px 0;
		border-radius: 4px;
	}
	.sidebar-img2 {
		height: 150px;
		width: 99%;
		margin: 20px 0;
		border-radius: 4px;
	}
	.body-article {
		display: flex;
		justify-content: space-between;
	}

	.body-article-header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 890px;
	}

	.body-article-header-name {
		font-size: 26px;
		color: #212121;
		margin-left: 16px;
	}

	.row-center {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.body-article-header-more {
		font-size: 12px;
		color: #212121;
	}

	.body-article-header-more-back {
		height: 12px;
		width: 6px;
		margin: 0 4px 0 10px;
	}

	.body-article-right {
		display: flex;
		flex-direction: column;
	}

	.body-article-right-col1 {
		height: 300px;
		width: 300px;
		position: relative;
		margin-top: 55px;
	}

	.body-article-right-col1-img {
		height: 270px;
		width: 300px;
		border-radius: 8px 8px 0px 0px;
	}

	.body-article-right-col1 div {
		height: 30px;
		width: 300px;
		position: absolute;
		bottom: 0;
		background-color: #747474;
		color: #ffffff;
		font-size: 16px;
		line-height: 30px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-radius: 0px 0px 8px 8px;
	}

	.body-article-right-col2-item {
		display: flex;
		flex-direction: row;
		height: 80px;
		width: 290px;
		background-color: #eeeeee;
		margin-bottom: 16px;
		border-radius: 8px;
	}

	.body-article-right-col2-item img {
		height: 80px;
		width: 120px;
		border-radius: 8px 0px 0px 8px;
		cursor: pointer;
	}

	.body-article-right-col2-item p {
		height: 22px;
		width: 170px;
		font-size: 14px;
		padding: 20px 12px;
		justify-content: center;
		display: flex;
		align-items: center;
		color: #212121;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		cursor: pointer;
	}

	.body-article-right-col3 {
		height: 360px;
		width: 290px;
		position: relative;
		cursor: pointer;
	}

	.body-article-right-col3 img {
		height: 330px;
		width: 290px;
	}

	.body-article-right-col3 div {
		height: 30px;
		width: 290px;
		position: absolute;
		bottom: 0;
		background-color: #747474;
		color: #ffffff;
		font-size: 16px;
		line-height: 30px;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-radius: 0px 0px 8px 8px;
	}
</style>
<style>
	.swiper-container-horizontal > .swiper-pagination-bullets {
		right: 0 !important;
		bottom: 6px;
		left: -16px;
	}

	.swiper-pagination-bullet-active {
		background: #28a3b1 !important;
		border: 1px solid #28a3b1 !important;
		border-radius: 50% !important;
	}

	.swiper-pagination {
		width: fit-content;
		text-align: end !important;
		padding-right: 10px !important;
	}

	.swiper-pagination-bullet {
		height: 18px !important;
		width: 18px !important;
		background-color: #fff;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(179, 179, 179, 1);
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue